export enum FirebasePersistence {
  Local = 'local',
  Session = 'session',
  None = 'none',
}
